import { useTheme } from 'contexts'
import { Dimensions } from 'react-native'

// Calculates the value of a single dimension for a given aspect ratio
export const useAspectRatio = ({
  // The combined offset in the known direction due to padding, borders, etc.
  aspectRatioOffset,
  // The unknown dimension to calculate, the other dimension should typically be set to 100%
  dimension,
  aspectRatio,
}: {
  aspectRatioOffset: number
  dimension: 'width' | 'height'
  aspectRatio: number
}) => {
  const { maxWidth } = useTheme()
  if (!aspectRatio) return 0

  if (dimension === 'width') {
    return (Dimensions.get('window').height - aspectRatioOffset) * aspectRatio
  }
  return (Math.min(Dimensions.get('window').width, maxWidth) - aspectRatioOffset) / aspectRatio
}
